export const CAPABILITIES = {
  LIMIT_WORKSPACES: 'LIMIT_WORKSPACES',
  LIMIT_PROJECTS_PER_WORKSPACE: 'LIMIT_PROJECTS_PER_WORKSPACE',
  LIMIT_INVITED_ACCOUNTS_PER_WORKSPACE: 'LIMIT_INVITED_ACCOUNTS_PER_WORKSPACE',
  LIMIT_TASKS_PER_WORKSPACE: 'LIMIT_TASKS_PER_WORKSPACE',
} as const;

export type CapabilityName = (typeof CAPABILITIES)[keyof typeof CAPABILITIES];

export const PLAN_DEFAULTS = {
  FREE: {
    [CAPABILITIES.LIMIT_WORKSPACES]: 1,
    [CAPABILITIES.LIMIT_PROJECTS_PER_WORKSPACE]: -1,
    [CAPABILITIES.LIMIT_INVITED_ACCOUNTS_PER_WORKSPACE]: 2,
    [CAPABILITIES.LIMIT_TASKS_PER_WORKSPACE]: -1,
  },
  PRO: {
    [CAPABILITIES.LIMIT_WORKSPACES]: 4,
    [CAPABILITIES.LIMIT_PROJECTS_PER_WORKSPACE]: -1,
    [CAPABILITIES.LIMIT_INVITED_ACCOUNTS_PER_WORKSPACE]: 10,
    [CAPABILITIES.LIMIT_TASKS_PER_WORKSPACE]: -1,
  },
} as const;

export type BillingPlan = keyof typeof PLAN_DEFAULTS;

export const isUnlimitedCapability = (value: number): boolean => value === -1;
